import _get from 'lodash-es/get';
import { connect } from 'react-redux';
import ReviewProgram from './ReviewProgram';
import { openErrorToast } from '../../../../../reducers/uiLogic';
import {
  createProgramInitiate,
  reviewProgramInitiate,
} from '../../../../../actions/programs';
import { currentFlowTypeEnum } from '../../../../common/components/constants';

const mapStateToProps = state => {
  const { programs = {} } = state;
  const { reviewProgramDetails = {}, response = {} } = programs;
  const isTwoFactorVisible = _get(state, 'twofactor.isVisible', false);
  const viewOnlyMode = _get(state, 'user.view_only_mode', false);
  const flowType = _get(
    state,
    'user.currentFlow',
    currentFlowTypeEnum.FLOW_TYPE_PPI,
  );
  return {
    flowType,
    viewOnlyMode,
    reviewProgramDetails,
    responseOfCreateProgram: response,
    isTwoFactorVisible,

    creatingProgram:
      _get(state, 'apiState.CREATE_PROGRAM.isFetching', false) &&
      !_get(state, 'apiState.CREATE_PROGRAM.isIdle', true),

    reviewingProgram:
      _get(state, 'apiState.REVIEW_PROGRAM.isFetching', false) &&
      !_get(state, 'apiState.REVIEW_PROGRAM.isIdle', true),

    reviewProgramSuccess: _get(state, 'apiState.REVIEW_PROGRAM.success', false),

    createProgramSuccess: _get(state, 'apiState.CREATE_PROGRAM.success', false),
  };
};

const mapDispatchToProps = dispatch => ({
  showErrorToast: message => dispatch(openErrorToast(message)),
  createProgram: payload => dispatch(createProgramInitiate(payload)),
  reviewProgram: payload => dispatch(reviewProgramInitiate(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ReviewProgram);
